<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
	<rect y="15" width="16" height="1" />
	<rect x="9" y="6" width="5" height="7" />
	<rect x="2" width="5" height="13" />
</svg>
</template>